import { FREQUENCY } from '@funnels/constants';
import { PropertyExpenses } from '@funnels/types';
import { getAnnualValueFromFrequency, getRateForFrequency } from '@funnels/utils';

export const getMonthlyPropertyExpenseValue = (propertyExpenses: PropertyExpenses[]) => {
  return propertyExpenses.reduce((sum: number, expense: PropertyExpenses) => {
    const { amount = 0, frequency } = expense;
    if (amount && frequency) {
      return sum + getRateForFrequency(getAnnualValueFromFrequency(amount, frequency), FREQUENCY.MONTHLY);
    }
    return sum;
  }, 0);
};
